import moment from 'moment';
import strings from '../localization';
var locales = require('moment/min/locales.min');

function setMomentLocale(local) {
  if (moment.locales().indexOf(local.toLowerCase()) > -1) {
    return moment.updateLocale(local.toLowerCase(), locales);
  } else {
    return moment.updateLocale('en', locales);
  }
}

export function convertMessagesArrayToObject(messages) {
  if (!messages || messages.length === 0) {
    return {};
  }
  let preparedMessageObject = {};
  messages.map((e) => {
    let messageId = e['mid'];
    preparedMessageObject[`${messageId}`] = e;
    return true;
  });
  return preparedMessageObject;
}

/**
 * Prepare messages to array and sort it by dateTime
 * @param {object} messageObj
 */
export function prepareMessages(messageObj, myIconUrl, memberIconUrl, userId) {
  let messages = { ...messageObj };
  let parsedMessages = [];
  let sortedMessages = sortMessagesFromObject(messages);
  sortedMessages.map((e) => {
    let preparedIcon =
      (e.sub_type === 'system' || e.sub_type === 'html') && isUserAdmin(userId)
        ? null
        : e.out === true
        ? myIconUrl
        : memberIconUrl;
    parsedMessages.push({
      messageTimestamp: formatChatMessages(
        parseInt(moment.utc(e.date, 'YYYY-MM-DD HH:mm:ss').unix(), 10)
      ),
      itsImage: e.type === 'image',
      message: e.msg,
      memberIconUrl: preparedIcon,
      messageDirection: e.out ? 1 : 0,
      msgType: e.type,
      msgSubType: e.sub_type,
      buttonText: e.button_text || null,
      description: e.description || null,
      headline: e.headline || null,
      promoId: e.promo_id || null,
    });
    return true;
  });
  // return parsedMessages;
  return groupMessages(parsedMessages);
}

export function sortMessagesFromObject(messagesObj) {
  return Object.values(messagesObj).sort((a, b) => {
    return parseInt(moment.utc(a.date, 'YYYY-MM-DD HH:mm:ss').unix(), 10) >=
      parseInt(moment.utc(b.date, 'YYYY-MM-DD HH:mm:ss').unix(), 10)
      ? 1
      : -1;
  });
}

/**
 * Format date for Individual chat messages
 * @param time unictimestamp
 * @return string
 */
export function formatChatMessages(time) {
  let deviceLocale = strings.getLanguage();
  let messageDate = new Date(time * 1000);
  let now = new Date();
  // let dayDifference = moment(now).diff(moment(messageDate), 'days');
  let dayDifference = moment(now)
    .clone()
    .startOf('day')
    .diff(moment(messageDate).clone().startOf('day'), 'days');
  let yearDifference = moment(now)
    .clone()
    .startOf('year')
    .diff(moment(messageDate).clone().startOf('year'), 'years');
  setMomentLocale(deviceLocale);
  if (yearDifference >= 1) {
    return moment(messageDate).format('ddd, MMM D YYYY, LT');
  } else if (dayDifference >= 8) {
    return moment(messageDate).format('ddd, MMM D, LT');
  } else if (dayDifference >= 2 && dayDifference < 8) {
    return moment(messageDate).format('dddd LT');
  } else if (dayDifference >= 0 && dayDifference < 2) {
    return (
      moment(messageDate).calendar().split(' ')[0] +
      ' ' +
      moment(messageDate).format('LT')
    );
  } else {
    return moment(messageDate).format('ddd, MMM D YYYY, LT');
  }
}

/**
 * Get message object and return msg array split by {{\\n}}
 * @param object msg
 */
export function prepareMessageTextArray(msg) {
  let msgNew = { ...msg };
  if (msgNew && msgNew.multiline) {
    return msgNew.message.split('{{\\n}}');
  }
  return [msgNew.message];
}

/**
 * Group messages by time, group only messages that is plain text and message direction
 * used for showing messages group by same time
 */
export function groupMessages(messages) {
  let array = [...messages];
  const groupedMessages = array.reduce((acc, cur) => {
    let lastAcc = acc[acc.length - 1];
    if (acc.length === 0) {
      return [...[], ...[cur]];
    }
    if (
      lastAcc['messageTimestamp'] === cur['messageTimestamp'] &&
      lastAcc['msgType'] === cur['msgType'] &&
      lastAcc['msgType'] === 'text' &&
      lastAcc['msgSubType'] === cur['msgSubType'] &&
      lastAcc['msgSubType'] === 'plain' &&
      lastAcc['messageDirection'] === cur['messageDirection']
    ) {
      lastAcc['message'] = [lastAcc['message'], cur['message']].join('{{\\n}}');
      lastAcc['multiline'] = true;
      return acc;
    } else {
      return [...acc, ...[cur]];
    }
  }, []);
  return [...groupedMessages];
}

export function richMsgLinkRegexps() {
  return {
    goVip:
      /^(.*?)(\[b\]\s*?)?\[link_govip\](.+?)\[\/\s{0,2}link_govip\](\s*?\[\/\s{0,2}b\])?(.*?)$/,
    uploadPhoto:
      /^(.*?)(\[b\]\s*?)?\[link_upload_photo\](.+?)\[\/\s{0,2}link_upload_photo\](\s*?\[\/\s{0,2}b\])?(.*?)$/,
    profileEdit:
      /^(.*?)(\[b\]\s*?)?\[link_profile_edit\](.+?)\[\/\s{0,2}link_profile_edit\](\s*?\[\/\s{0,2}b\])?(.*?)$/,
    browse:
      /^(.*?)(\[b\]\s*?)?\[link_browse\](.+?)\[\/\s{0,2}link_browse\](\s*?\[\/\s{0,2}b\])?(.*?)$/,
    bold: /^(.*?)\[b\](.+?)\[\/\s{0,2}b\](.*?)$/,
  };
}

export function isUserAdmin(userId) {
  return (
    userId.toLowerCase().includes('admin') ||
    userId.toLowerCase().includes('inboxdeals')
  );
}
